import { render } from "./CommonDataPanel.vue?vue&type=template&id=0ad30162&scoped=true"
import script from "./CommonDataPanel.vue?vue&type=script&lang=js"
export * from "./CommonDataPanel.vue?vue&type=script&lang=js"

import "./CommonDataPanel.vue?vue&type=style&index=0&id=0ad30162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad30162"]])

export default __exports__